
    /**
     * При загрузки страницы выбираем первый тариф для почтой
     */
    if( !isProstoboxCalc() ){
        selectTariff($('.calculator__tariff__item:first'));
    }


    /**
     * Открыть дополнительные параметры
     */
    eventClick('.calculator__params', function(event){

        event.toggleClass('active');

        $('.calculator .calculator__fields').toggleClass('show-extra-params');

    });


    /**
     * Проставляем индекс при выборе города и также меняем хеш региона, города, страны и индекса
     */
    setEventListener('city_selected', function (event, city){
        if (city.country){

            $('input[name="postcode"]').val(city.post_code);
            params[0][1] = city.country.iso ;
            params[3][1] = city.name['ru'] ? city.name['ru'] : city.name['en'];

            //если проект простобокс
            if ( isProstoboxCalc() ){

                params[5][1] = city.region ? city.region.name['ru'] ? city.region.name['ru'] : city.region.name['en']: "";
                params[6][1] = city.post_code;

            } else {

                params[4][1] = city.post_code;

            }

            window.location.hash = createURL(params);
        }
    });


    /**
     * Рассчитать цену в калькуляторе
     */
    let active_tariff_data_id;


    /**
     * Нажатие на кнопку рассчитать
     */
    eventSubmit('.calculator__form', function (form){

        calculate();

    });


    /**
     * Отправить запрос на сервер и рассчитать тарифы
     */
    window.calculate = function (){

        if( isPageLoadingNow() )
            return false;

        if( !$('.calculator__form').find('input[name="weight"]').val().length )
            return showError('Укажите вес.');

        pageLoadingStart();

        $('.calc2__loader').addClass('active')
        $('.calculator__info').hide()
        $('.calculator__tariff').hide()

        request('POST', '/calculator/calculate', getFormData($('.calculator__form')), function (response_html){

            $('.calculator__tariff').html(response_html);

            //Делаем тариф активным по значению data-id
            if( $('.calculator__tariff .calculator__tariff__item').length ){

                if ( isProstoboxCalc() ){

                    if (active_tariff_data_id !== undefined){
                        let selected_tariff = $('.calculator__tariff[data-id="' + active_tariff_data_id + '"]')
                        if (selected_tariff.length){
                            selected_tariff.toggleClass('tariffs__item-open').next().slideToggle();
                        } else {
                            active_tariff_data_id = undefined;
                        }

                    }

                } else {

                    let first_tariff = $('.calculator__tariff__item[data-id="' + active_tariff_data_id + '"]')
                    if (first_tariff.length){
                        selectTariff(first_tariff);
                    } else {
                        active_tariff_data_id = undefined;
                    }

                }

                $('.calculator__info').show()
                $('.calculator__tariff').show()


            }

            //Если калькулятор простобокс
            if( isProstoboxCalc() ){

                //Если не одного тарифа не найдено
                if( $('.calculator__tariff.tariffs__list .tariffs__item').length === 0 ){

                    $('.calculator__tariffs_list.calculator__info').show();
                    $('.calculator__tariff.tariffs__list').show().html('<li><div class="calculator__info__warning">По Вашим параметрам не найдено ни одного тарифа. Скорее всего, мы не сможем отправить вашу посылку. Обратитесь в поддержку сервиса.</div></li>');
                    active_tariff_data_id = undefined;

                }

            //Калькулятор почтой
            }else{

                //Если не одного тарифа не найдено
                if( $('.calculator__tariff .calculator__tariff__item:not(.not-available)').length === 0 ){

                    $('.calculator__info .calculator__info__content').html('<div class="calculator__info__warning">По Вашим параметрам не найдено ни одного тарифа. Скорее всего, мы не сможем отправить вашу посылку. Обратитесь в поддержку сервиса.</div>');
                    $('.calculator__tariff__item.active').removeClass('active');
                    active_tariff_data_id = undefined;

                }

            }

            //Если не выбран не один тариф
            if( active_tariff_data_id === undefined && !isProstoboxCalc() ){

                selectTariff($('.calculator__tariff__item:first'));

            }


            $('.calc2__loader').removeClass('active');
            initTooltips();
            pageLoadingEnd();

            window.location.hash = createURL(params);


        }, function (error,code) {

            showError(error,code);
            $('.calc2__loader').removeClass('active')
            $('.calculator__info').show()
            $('.calculator__tariff').show()
            pageLoadingEnd();

            window.location.hash = createURL(params);

        });

    }


    /**
     * Выбор конкретного тарифа (почтой)
     */
    eventClick('.calculator__tariff__item', function (elem){

        if ( !isProstoboxCalc() ){
            active_tariff_data_id = elem.data('id');
            selectTariff(elem);
        }

    });


    /**
     * Показать информацию о тарифе (выбор тарифа)
     */
    function selectTariff (elem){

        if( isProstoboxCalc() ){

            if ( !elem.hasClass('tariffs__item-open') ) {

                $(elem).addClass('tariffs__item-open').next().slideDown();
                active_tariff_data_id = elem.data('id');

            } else {

                $(elem).removeClass('tariffs__item-open').next().slideUp();
                active_tariff_data_id = undefined;

            }

        }else{

            if( $(elem).hasClass('active') )
                return;

            $('.calculator__tariff__item.active').removeClass('active');

            $(elem).addClass('active');

            $('.calculator__info').html($(elem).find('.calculator__info__tariff').html());

        }

    }

    /**
     * Переключение на регулярный прайс или постоянным клиентам
     */
    eventClick('.price_change', function (data) {
        if (!data.hasClass('active')) {

            $('.price_change.active').removeClass('active');
            data.toggleClass('active')

            if ($('.price_change:last').hasClass('active')) {
                data.css('margin-left', '20px');
                $('#client_type').val(1)
                params[12][1] = 'regular'
            } else {
                $('.price_change:last').css('margin-left', '0');
                $('#client_type').val(0)
                params[12][1] = 'normal'
            }

            calculate();

        }

    })

    /**
     *Кодируем параметры
     */
    function encodeParams(params) {
        return encodeURIComponent(JSON.stringify(params));
    }
    /**
     * Создаем url
     */
    function createURL(params) {
        return `#${encodeParams(params)}`;
    }

    /**
    * Параметры для создания хеша
    */
    let params = [];
    //если проект простобокс
    if ( isProstoboxCalc() ){
        params = [
            ["country", ""],
            ["package-weight", ""],
            ["package-weight-unit", ""],
            ["city", ""],
            ["zip", ""],
            ["priceProduct", ""],
            ["calcLength", ""],
            ["calcWidth", ""],
            ["calcHeigth", ""],
        ];
    } else {
        params = [
            ["calcCountry", ""],
            ["calcPackageWeight", ""],
            ["calcWeightUnit", ""],
            ["calcCity", ""],
            ["preset_city", ""],
            ["calcRegion", ""],
            ["calcZip", ""],
            ["preset_zip", ""],
            ["calcPackagePrice", ""],
            ["calcPackageLength", ""],
            ["calcPackageWidth", ""],
            ["calcPackageHeight", ""],
            ["client_type", ""]
        ];
    }



    /**
     * При изменении значения веса сгенерируем хеш заново
     */
    eventInput('#weight', function (data) {
        params[1][1] = data.val();
        window.location.hash = createURL(params);
    })

    /**
     * При изменении значения единицы измерения в почтой сгенерируем хеш заново
     */
    eventChange('#measure_unit', function (data) {
        params[2][1] = data.val();
        window.location.hash = createURL(params);

        if (data.val() === 'lb') {

            $('#calc_height_unit').text('дюймы');
            $('#calc_length_unit').text('дюймы');
            $('#calc_width_unit').text('дюймы');

        } else {

            $('#calc_height_unit').text('см');
            $('#calc_length_unit').text('см');
            $('#calc_width_unit').text('см');

        }

    });

    /**
     * При изменении значения индекс измерения сгенерируем хеш заново
     */
    eventInput('#postcode', function (data){
        if ( isProstoboxCalc() ){
            params[4][1] = data.val();
        } else {
            params[6][1] = data.val();
        }

        window.location.hash = createURL(params);
    });

    /**
     * При изменении значения стоимость товара сгенерируем хеш заново
     */
    eventInput('#cost_items', function (data){
        if ( isProstoboxCalc() ){
            params[5][1] = data.val();
        } else {
            params[8][1] = data.val();
        }
        window.location.hash = createURL(params);
    });

    /**
     * При изменении значения длина товара сгенерируем хеш заново
     */
    eventInput('#x', function (data){
        if ( isProstoboxCalc() ){
            params[6][1] = data.val();
        } else {
            params[9][1] = data.val();
        }
        window.location.hash = createURL(params);
    });

    /**
     * При изменении значения ширина товара сгенерируем хеш заново
     */
    eventInput('#y', function (data){
        if ( isProstoboxCalc() ){
            params[7][1] = data.val();
        } else {
            params[10][1] = data.val();
        }
        window.location.hash = createURL(params);
    });

    /**
     * При изменении значения высота товара сгенерируем хеш заново
     */
    eventInput('#z', function (data){
        if ( isProstoboxCalc() ){
            params[8][1] = data.val();
        } else {
            params[11][1] = data.val();
        }
        window.location.hash = createURL(params);
    });

    /**
     * При изменении значения единицы измерения в простобоксе сгенерируем хеш заново
     */
    eventClick('.select-items div', function (data) {

        params[2][1] = data.data('val');
        window.location.hash = createURL(params);

        if (data.data('val') === 'lb') {

            $('#calc_height_unit').text('дюймы');
            $('#calc_length_unit').text('дюймы');
            $('#calc_width_unit').text('дюймы');

        } else {

            $('#calc_height_unit').text('см');
            $('#calc_length_unit').text('см');
            $('#calc_width_unit').text('см');

        }
    })



    /**
     * По загрузке страницы проверяем содержит ли хэш ссылка, если да то отправляем запрос по калькулятору
     */
    window.onload = () => {
        let measure_unit;

        if (window.location.hash){

            let decodedString = decodeURIComponent(window.location.hash);

            decodedString = decodedString.substring(1);

            params = JSON.parse(decodedString);

            scrollToElem('.calculator');

            //TODO убрать потом этот ужас с двойными ajax запросами, передавая на бекенд данные сразу вместо city_id
            //получаем id города по названию города из хеша, так как чтобы отправить запрос на калькулятор нужен city_id
            request('GET', `/city/searchByName?country=${params[0][1]}&region=${params[5][1]}&city=${params[3][1]}`, function (response){

                if (response.city){

                    $('#weight').val(params[1][1])

                    measure_unit =params[2][1];

                    $('#measure_unit').val(measure_unit);

                    //если проект простобокс
                    if ( isProstoboxCalc() ){
                        $('#postcode').val(params[4][1])

                        if (typeof params[5] !== 'undefined' &&
                            typeof params[5][1] !== 'undefined' &&
                            !isNaN(parseFloat(params[5][1]))) {
                            const price = parseFloat(params[5][1]).toFixed(2);
                            $('#cost_items').val(price)

                        } else {
                            $('#cost_items').val(params[5][1])
                        }

                        if (params[6][1] != 0) {
                            $('#x').val(params[6][1])
                        }
                        if (params[7][1] != 0) {
                            $('#y').val(params[7][1])
                        }
                        if (params[8][1] != 0) {
                            $('#z').val(params[8][1])
                        }

                        $('.select-selected').text($('.select-items div[data-val="' + params[2][1] + '"]').text());
                        $('.select-items div').removeClass('same-as-selected');
                        $('.select-items div[data-val="' + params[2][1] + '"]').addClass('same-as-selected');

                    } else {
                        $('#postcode').val(params[6][1])

                        if (typeof params[8] !== 'undefined' &&
                            typeof params[8][1] !== 'undefined' &&
                            !isNaN(parseFloat(params[8][1]))) {
                            const price = parseFloat(params[8][1]).toFixed(2);
                            $('#cost_items').val(price)

                        } else {
                            $('#cost_items').val(params[8][1])
                        }

                        if (params[9][1] != 0) {
                            $('#x').val(params[9][1])
                        }
                        if (params[10][1] != 0) {
                            $('#y').val(params[10][1])
                        }
                        if (params[11][1] != 0) {
                            $('#z').val(params[11][1])
                        }

                        $('#client_type').val(params[12][1] === 'regular' ? 1 : 0)
                    }


                    //Если постоянный клиент переключаем на раздел со скидками на постоянных клиентов
                    if ($('#client_type').val() == 1){
                        if (!$('.price_change:last').hasClass('active')) {
                            $('.price_change.active').removeClass('active');
                            $('.price_change:last').addClass('active').css('margin-left', '20px')
                        }
                    } else {
                        if ($('.price_change:last').hasClass('active')){
                            $('.price_change:first').addClass('active')
                            $('.price_change:last').removeClass('active').css('margin-left', '0')
                        }
                    }

                    let active_select2_instances = $('.select2-init');
                    //в селекте в форме вставляем город которого мы нашли из хеша по названию и делаем его выбранным
                    active_select2_instances.each(function() {
                        let newOption = new Option(`${langText(response.city.name)}<span>${response.city.region
                                                        ? langText(response.city.region.name) + ', ' + langText(response.city.country.name)
                                                        : langText(response.city.country.name)}</span>`, response.city.id, true, true);
                        $(this).append(newOption).trigger('change');
                    });

                    defineMeasureUnit(measure_unit);

                    calculate();

                }

            })
        } else {

            if ( isProstoboxCalc() ){
                params[4][1] = $('#postcode').val()
            } else {
                params[6][1] = $('#postcode').val()
            }
            params[1][1] = $('#weight').val()
            measure_unit = $('#measure_unit').val();
            params[2][1] = measure_unit;
            params[0][1] = $('select[name="city_id"]').find('option:selected').data('iso');
            params[3][1] = $('select[name="city_id"]').find('option:selected').data('city');

            defineMeasureUnit(measure_unit);
        }

    }


    function defineMeasureUnit(measure_unit){
        if (measure_unit === 'lb') {

            $('#calc_height_unit').text('дюймы');
            $('#calc_length_unit').text('дюймы');
            $('#calc_width_unit').text('дюймы');

        } else {

            $('#calc_height_unit').text('см');
            $('#calc_length_unit').text('см');
            $('#calc_width_unit').text('см');

        }
    }


    /**
     * Открытие доп. параметров (размеры посылки) в калькуляторе простобокс
     */
    eventClick('.calc .group-show-more', function () {
        $('.group-hide').toggleClass('active');
        $('.group-show-more').toggleClass('open');
    });


    /**
     * Открыть/закрыть (выбрать) тариф на простобоксе
     */
    eventClick('.tariffs__item', function (elem) {

        selectTariff(elem);
        ///$('.tariffs__item').not(data).removeClass('tariffs__item-open').next().hide();

        // if ( !elem.hasClass('tariffs__item-open') ) {
        //
        //     $(elem).addClass('tariffs__item-open').next().slideUp();
        //     active_tariff_data_id = data.data('id');
        //
        // } else {
        //
        //     $(elem).removeClass('tariffs__item-open').next().slideDown();
        //     active_tariff_data_id = undefined;
        //
        // }

    })


    /**
     * Открыт сейчас простобокс калькулятор или почтой
     * @returns {jQuery}
     */
    function isProstoboxCalc(){
        return $('.prostobox_calc').length;
    }
